module.exports = __webpack_public_path__ + "img/1ad0f5db94e27f8471c9c33ecc59e76a.png";